import React from "react";
import Slider from "react-slick";
import { Container, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const NewsAndEvents = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "ease-in-out",
    pauseOnHover: false,
    rtl: false,
    centerMode: true,
    centerPadding: "50px",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, centerPadding: "30px" } },
      { breakpoint: 768, settings: { slidesToShow: 1, centerPadding: "20px" } }
    ]
  };

  const items = [
    { title: "Annual General Meeting", date: " 2025", img: "/assets/img1.jpg", details: "Join us for our AGM where we discuss progress, upcoming plans, and financial reports." },
    { title: "Financial Literacy Workshop", date: " 2025", img: "/assets/img2.jpg", details: "Learn how to manage finances, save, and invest wisely in this interactive workshop." },
    { title: "Member Networking Event", date: " 2025", img: "/assets/img3.jpg", details: "An opportunity to connect with fellow members, share insights, and explore partnerships." },
    { title: "New Loan Products Introduced", date: " 2025", img: "/assets/img11.jpg", details: "We have introduced new loan products to cater to your financial needs. Check them out today!" },
    { title: "Interest Rate Adjustment", date: " 2025", img: "/assets/img8.jpg", details: "Effective next quarter, there will be an adjustment in our loan interest rates. Learn more inside." },
  ];

  return (
    <>
      <Navbar />
      {/* Added more space below the navbar to prevent title overlap */}
      <Container className="py-5 mt-40">
        {/* Fancy Title with proper spacing */}
        <h2 className="text-center mb-2 text-4xl font-bold bg-gradient-to-r from-blue-400 to-purple-500 text-transparent bg-clip-text">
          Latest News & Events 🚀
        </h2>

        <Card className="p-6 shadow-lg bg-opacity-20 backdrop-blur-lg bg-white/30 border border-gray-200 rounded-xl">
         
          <Slider {...settings}>
            {items.map((item, index) => (
              <div key={index} className="flex justify-center">
                <div className="w-[320px] h-[420px] bg-white bg-opacity-80 rounded-lg shadow-lg text-center p-5 transition-transform transform hover:scale-105 hover:shadow-2xl">
                  <img 
                    src={item.img} 
                    alt={item.title} 
                    className="w-full h-[200px] object-cover rounded-md mb-4 transition-all duration-300 hover:scale-110"
                  />
                  <h3 className="text-xl font-semibold text-gray-800">{item.title}</h3>
                  <p className="text-gray-600 font-medium">{item.date}</p>
                  <p className="text-gray-600">{item.details}</p>
                </div>
              </div>
            ))}
          </Slider>
        </Card>
      </Container>

      <Footer />
    </>
  );
};

export default NewsAndEvents;
